module.exports = __webpack_public_path__ + "media/sanctuary-master-720.fac15989.mp4";